import { gsap, ScrollTrigger } from 'gsap/all'
gsap.registerPlugin(ScrollTrigger)

export function divider(
  element: HTMLElement,
  scrolltriggerAttributes?: { trigger?: HTMLElement; start?: string; end?: string; markers?: boolean }
) {
  const { trigger, start, end, markers } = scrolltriggerAttributes || {}

  const parentSection = element.closest('section')
  let mm = gsap.matchMedia()
  // get inner svg path
  const underline = element.querySelector('.js-inner')

  mm.add('(min-width: 992px)', () => {
    const anim = gsap
      .timeline({
        scrollTrigger: {
          trigger: trigger || parentSection,
          start: start || 'top center',
          end: end || 'bottom center',
          scrub: 0.9,
          invalidateOnRefresh: true,
          markers: markers || false
        }
      })
      .fromTo(
        underline,
        { xPercent: -100 },
        {
          xPercent: 0,
          ease: 'expo.out'
        }
      )
  })
}
